import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CapabilityService } from "../../../../auth/service/capability.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { RoleService } from "../../../../auth/service/role.service";
import { ICapability, ICapabilityForm } from "app/auth/models/capabilities";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IRole } from "app/auth/models";

@Component({
  selector: "app-capability-form",
  templateUrl: "./capability-form.component.html",
  styleUrls: ["./capability-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CapabilityFormComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public isEdit: boolean = false;
  public capability_id: number = 0;
  public showErrors: boolean = false;
  public assign_role: Array<number> = [];
  public role_list: IRole[] = [];
  public oldCapabilities: Array<number> = [];

  constructor(
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public _capabilityService: CapabilityService,
    private router: Router,
    private activated_route: ActivatedRoute,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _roleService: RoleService,
  ) {
    this.formGroup = this._formBuilder.group({
      name: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      description: new FormControl(""),
      code: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
    });

    this.activated_route.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        this.isEdit = true;
        this.capability_id = Number(params.id);
      }
    });
  }

  async ngOnInit() {
    this.role_list = await this._roleService.getList();
    this.role_list = this.role_list.filter((role) => role.name !== "Dipendente" && role.name !== "Candidato");
    this.contentHeader = {
      headerTitle: this.isEdit ? "EDIT_CAPABILITY" : "ADD_CAPABILITY",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "TITLES.CAPABILITY_USERS",
            isLink: true,
            link: "/dashboard/capability/list",
          },
          {
            name: this.isEdit ? "EDIT" : "ADD",
            isLink: false,
          },
        ],
      },
    };

    if (this.isEdit) {
      const capability: ICapability = await this._capabilityService.get(this.capability_id);

      if (!capability) {
        await this.router.navigateByUrl("/dashboard/capability/list");
      } else {
        this.formGroup.patchValue({ name: capability.name });
        this.formGroup.patchValue({ description: capability.description });
        this.formGroup.patchValue({ code: capability.code });
        if (capability.role_ids && capability.role_ids.length > 0) {
          capability.role_ids.forEach((roleId) => {
            if (typeof roleId === "number") {
              this.assign_role.push(roleId);
              this.oldCapabilities.push(roleId);
            }
          });
        }
        this._changeDetectorRef.detectChanges();
      }
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async create() {
    if (!this._authenticationService.hasCapability("create_capability")) {
      window.history.back();
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    const data: ICapabilityForm = {
      name: String(this.formGroup.value.name).trim(),
      code: String(this.formGroup.value.code).trim(),
      description: String(this.formGroup.value.description).trim(),
    };
    await this._capabilityService
      .create(data)
      .then(async (response: { messagge: string; data: ICapability }) => {
        if (this.assign_role && this.assign_role.length > 0 && this._authenticationService.hasCapability("assign_role")) {
          this._capabilityService
            .assign_unssign(response.data.id, this.assign_role, [])
            .then(async () => {
              await this._utilService
                .showSWAL({
                  title: "COMPLETED_TITLE",
                  text: "SUCCESS_UPLOAD_CAPABILITY",
                  icon: "success",
                  confirmButtonText: "BTN_CLOSE",
                  showCancelButton: false,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                })
                .then(async () => {
                  await this.router.navigateByUrl("/dashboard/capability/list");
                });
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showSWALError({ text: "ERROR_CAPABILITY_ASSIGN" });
            });
        } else {
          await this.router.navigateByUrl("/dashboard/capability/list").then(async () =>
            this._utilService.showSWAL({
              title: "COMPLETED_TITLE",
              text: "SUCCESS_UPLOAD_CAPABILITY",
              icon: "success",
              confirmButtonText: "BTN_CLOSE",
              showCancelButton: false,
              customClass: {
                confirmButton: "btn btn-success",
              },
            }),
          );
        }
      })
      .catch(async () =>
        this._utilService.showSWAL({
          title: "ALERT_TITLE",
          text: "ERROR_CREATE_CAPABILITY",
          icon: "error",
          confirmButtonText: "BTN_CLOSE",
          showCancelButton: false,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        }),
      );
  }

  async update() {
    if (!this._authenticationService.hasCapability("update_capability")) {
      window.history.back();
      return false;
    }
    let unassign: Array<number> = [];
    if (this.oldCapabilities && this.oldCapabilities.length > 0) {
      this.oldCapabilities.map((roleId) => {
        if (!this.assign_role.includes(roleId)) {
          unassign.push(roleId);
        }
      });
    }
    delete this.formGroup.value.code;
    const data: ICapabilityForm = {
      name: String(this.formGroup.value.name).trim(),
      description: String(this.formGroup.value.description).trim(),
    };
    await this._capabilityService
      .update(this.capability_id, data)
      .then(async () => {
        if (((this.assign_role && this.assign_role.length > 0) || (unassign && unassign.length > 0)) && this._authenticationService.hasCapability("assign_role")) {
          this._capabilityService
            .assign_unssign(this.capability_id, this.assign_role, unassign)
            .then(async () => {
              this._utilService
                .showSWAL({
                  title: "COMPLETED_TITLE",
                  text: "SUCCESS_EDIT_CAPABILITY",
                  icon: "success",
                  confirmButtonText: "BTN_CLOSE",
                  showCancelButton: false,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                })
                .then(async () => {
                  await this.router.navigateByUrl("/dashboard/capability/list");
                });
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showSWALError({ text: "ERROR_CAPABILITY_ASSIGN" });
            });
        } else {
          await this.router.navigateByUrl("/dashboard/capability/list").then(async () =>
            this._utilService.showSWAL({
              title: "COMPLETED_TITLE",
              text: "SUCCESS_EDIT_CAPABILITY",
              icon: "success",
              confirmButtonText: "BTN_CLOSE",
              showCancelButton: false,
              customClass: {
                confirmButton: "btn btn-success",
              },
            }),
          );
        }
      })
      .catch(() =>
        this._utilService.showSWAL({
          title: "ALERT_TITLE",
          text: "ERROR_EDIT_CAPABILITY",
          icon: "error",
          confirmButtonText: "BTN_CLOSE",
          showCancelButton: false,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        }),
      );
  }

  assignRole(id: number) {
    if (this.assign_role.includes(id)) {
      this.assign_role = this.assign_role.filter((role) => role !== id);
    } else {
      this.assign_role.push(id);
    }
  }
}
